import React from 'react'

import {DialogProps} from '../Dialog/Dialog'
import {isString} from 'lodash'
import ConfirmDialog from '../ConfirmDialog'
import ConfirmDialogButton from '../ConfirmDialog/ConfirmDialogButton'
import ConfirmDialogContent from '../ConfirmDialog/ConfirmDialogContent'
import ConfirmDialogFooter from '../ConfirmDialog/ConfirmDialogFooter'
import ConfirmDialogHeader from '../ConfirmDialog/ConfirmDialogHeader'
import Loader from '../Loader'

type QuickConfirmDialogProps = Omit<DialogProps, 'children'> & {
  title: string
  content: React.ReactNode
  closeButton?: boolean
  buttons?: (React.ComponentProps<typeof ConfirmDialogButton> & {
    title: string
    isLoading?: boolean
    customButtonProps?: Partial<React.ComponentProps<typeof ConfirmDialogButton>>
  })[]
  cancelButton?: boolean | string
  maxWidth?: string
  overflowY?: string
}

const QuickConfirmDialog: React.FC<QuickConfirmDialogProps> = ({
  title,
  content,
  buttons,
  cancelButton = true,
  closeButton = false,
  maxWidth = '400px',
  overflowY = 'hidden',
  ...props
}) => {
  return (
    <ConfirmDialog {...props} maxWidth={maxWidth} overflowY={overflowY}>
      <ConfirmDialogHeader title={title} closeButton={closeButton} />
      <ConfirmDialogContent>{content}</ConfirmDialogContent>
      <ConfirmDialogFooter>
        {cancelButton && <ConfirmDialogButton>{isString(cancelButton) ? cancelButton : 'Cancel'}</ConfirmDialogButton>}
        {buttons?.map(({title, isLoading, customButtonProps, ...btnProps}) => (
          <ConfirmDialogButton key={title} customButtonProps={customButtonProps} {...btnProps}>
            {isLoading && <Loader size={10} />}
            {title}
          </ConfirmDialogButton>
        ))}
      </ConfirmDialogFooter>
    </ConfirmDialog>
  )
}

export default QuickConfirmDialog
